import React from 'react';
import PageTop from '../../../core/components/PageTop';
import PayorListTable from './table/PayorListTable';
import { usePayorListInit } from './pagehooks/usePayorListInit';

const PageAdminPayorEdit = (): JSX.Element => {
    usePayorListInit();

    return (
        <>
            <PageTop
                title="Excluded Payor List"
                icon="sprite-payor"
            />
            <div className="payor-feature payor-list">
                <PayorListTable />
            </div>
        </>
    );
};

export default PageAdminPayorEdit;
